<template>
  <div class="image-container" :class="{'reverse':reverse}">
    <img @click="showPhotoSwipe(i)" v-for="(item,i) in items" :src="item.path" :srcset="item.srcSet" :key="i" alt="">
  </div>
</template>

<script>

export default {
  name: 'QuestionImages',
  props: {
    images: {type: Array},
    reverse: {type: Boolean, default: false}
  },
  data() {
    return {
      isOpen: false,
      options: {
        index: 0
      },
      items: this.getItems()
    }
  },
  computed: {
    photoSwipeItems() {
      return this.items.map(i => i.responsives[0])
    }
  },
  methods: {
    getItems() {
      if (!this.images) return []
      return this.images.map(i => {
        const medias = i.responsive_images.media_library_original
        const responsives = medias ? medias.urls : []
        const path = i.path
        const base = path.substring(0, path.lastIndexOf("/")) + '/responsive-images/'
        const data = {
          path: path,
          file_name: i.file_name,
          responsives: responsives.map(url => {
            let p = url.lastIndexOf('.')
            let tmp = url.substring(0, p)
            p = tmp.lastIndexOf('_')
            const height = parseInt(tmp.substring(p + 1, tmp.length))
            tmp = tmp.substring(0, p)
            p = tmp.lastIndexOf('_')
            const width = parseInt(tmp.substring(p + 1, tmp.length))
            return {title: i.file_name, w: width, h: height, src: base + url}
          })
        }
        data.srcSet = data.responsives.map(r => `${r.src} ${r.w}w`).join(',')
        if (data.responsives.length === 0) data.responsives = [{title: i.file_name, src: path, w: 500, h: 500}]
        return data
      })
    },
    showPhotoSwipe(index) {
      this.$root.$emit('show-photoswipe', this.photoSwipeItems, index)
    }
  }
}
</script>

<style lang="scss" scoped>

.image-container {
  display: flex;
  flex-wrap: wrap;
  @include gap-items-x(1.66%);

  &.reverse {
    flex-direction: row-reverse;
  }

  > * {
    &:nth-child(5n) {
      margin-left: 0;
    }

    &:nth-child(5n+4) {
      margin-right: 0;
    }
  }

  img {
    object-fit: cover;
    margin-bottom: 10px;
    width: 22.5%;
    height: auto;
    max-height: 100px;
    cursor: pointer;
  }
}
</style>
